/**
 * Modelos de la toma de asistencia POR EVENTO del BO, contra el mismo motor que el mobile
 * (`/bo/events/:id/attendance*`). Distinto del ABM de registros sueltos de `models/attendance.ts`:
 * acá hay sesión, padrón y cierre, igual que en la app.
 */

export type AttendanceSessionStatus = "in_progress" | "completed";

export interface EventAttendanceSession {
  id: number;
  status: AttendanceSessionStatus;
  startedAt: string;
  completedAt: string | null;
}

export interface EventAttendanceSummary {
  total: number;
  present: number;
  absent: number;
  unmarked: number;
}

export interface EventAttendee {
  /** id de la fila event_attendance. null = todavía sin marcar (se crea con `mark`). */
  id: number | null;
  userId: number | null;
  companionId: string | null;
  name: string;
  email: string | null;
  avatarUrl: string | null;
  /** true presente, false ausente, null sin marcar. */
  isPresent: boolean | null;
  isCompanion: boolean;
  companionOf: number | null;
  markedAt: string | null;
  companionsCount: number;
  /**
   * Fila del anfitrión que asiste: presente forzado y no marcable. El backend la incluye sólo
   * en el padrón del BO (en mobile el anfitrión es el tomador y su fila se oculta).
   */
  isHost: boolean;
}

export interface EventAttendanceRoster {
  session: EventAttendanceSession;
  summary: EventAttendanceSummary;
  attendees: EventAttendee[];
}

/** Sujeto a marcar: titular (user_id) o acompañante (companion_id), nunca los dos. */
export type AttendanceSubject =
  | { userId: number; companionId?: undefined }
  | { companionId: string; userId?: undefined };

/** El padrón se cierra sólo cuando no queda nadie sin marcar. */
export const canCompleteAttendance = (summary: EventAttendanceSummary): boolean =>
  summary.total > 0 && summary.unmarked === 0;
